// Shared Freshdesk ticket status label map (matches backend STATUS_MAP)
export const TICKET_STATUS_MAP: Record<number, string> = {
    2: 'Open',
    3: 'Pending',
    4: 'Resolved',
    5: 'Closed',
    11: 'Chatbot - Resolved',
    12: 'Responded',
    13: 'Pending by Customer',
    14: 'Pending by Moglix',
    15: 'Resolved Email',
};

// Ant Design tag color mapping for each ticket status
export const TICKET_STATUS_COLOR_MAP: Record<number, string> = {
    2: 'orange',
    3: 'blue',
    4: 'green',
    5: 'default',
    11: 'cyan',
    12: 'geekblue',
    13: 'gold',
    14: 'volcano',
    15: 'lime',
};

// Resolve human-readable label from ticket status code
export const getTicketStatusLabel = (status: number): string =>
    TICKET_STATUS_MAP[status] || 'Unknown';

// Status codes considered "open" (active / pending action)
export const OPEN_TICKET_STATUSES = new Set([2, 3, 13, 14]);

// Returns true if the ticket status is considered open
export const isTicketOpen = (status: number): boolean => OPEN_TICKET_STATUSES.has(status);

// Resolve Ant Design tag color from ticket status code
export const getTicketStatusColor = (status: number): string =>
    TICKET_STATUS_COLOR_MAP[status] || 'default';

// Freshdesk ticket priority label map (matches backend PRIORITY_MAP)
export const PRIORITY_MAP: Record<number, string> = {
    1: 'Low',
    2: 'Medium',
    3: 'High',
    4: 'Urgent',
};

// Ant Design tag color mapping for each ticket priority
export const PRIORITY_COLOR_MAP: Record<number, string> = {
    1: 'blue',
    2: 'green',
    3: 'orange',
    4: 'red',
};

// Resolve human-readable label from ticket priority code
export const getTicketPriorityLabel = (priority: number): string =>
    PRIORITY_MAP[priority] || `Priority ${priority}`;

// Resolve Ant Design tag color from ticket priority code
export const getTicketPriorityColor = (priority: number): string =>
    PRIORITY_COLOR_MAP[priority] || 'default';

// Freshdesk ticket source channel map (matches backend SOURCE_MAP)
export const SOURCE_MAP: Record<number, string> = {
    1: 'Email',
    2: 'Portal',
    3: 'Phone',
    4: 'Forum',
    5: 'Twitter',
    6: 'Facebook',
    10: 'Outbound Email',
};

// Resolve human-readable label from ticket source code
export const getSourceLabel = (source: number): string =>
    SOURCE_MAP[source] || `Source ${source}`;
